<template>
	<div class="text-input">
		<label :for="$attrs.name" v-if="label">
			{{ label }}
		</label>
		<div class="field">
			<input v-bind="$attrs" 
				:class="{ center }"
				:type="$attrs.type ?? false ? $attrs.type : (password ? 'password' : 'text')" 
				:value="text" 
				@input="onInput"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'TextInput',

	props: {
		label: { type: String, default: '' },
		password: { type: Boolean, default: false },
		text: { type: String, default: '' },
		center: { type: Boolean, default: false }
	},

	setup (props, { emit }) {
		function onInput (e: any) {
			emit('update:text', e.target.value)
		}
		return {
			onInput
		}
	}

})
</script>

<style lang="scss" scoped>
.text-input {
	display: block;
	padding-bottom: 0.5rem;
	width: 100%;

	.field {
		width: 100%;
		
		input {
			color: #eee;
			font-size: 1.5rem;
			margin-bottom: 6px;
			background: rgba(0, 0, 0, 0.5);
			border: black;
			padding: 6px;
			box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.33);
			width: 100%;

			&.center {
				text-align: center;
			}
		}
	}
	label {
		padding: 12px 0;
		font-size: 18px;
		font-weight: 600;
	}
	label, .field {
		display: block;
	}
}
</style>